import { DeleteFilled, EditOutlined, EyeFilled } from "@ant-design/icons";
import {
  Button,
  Col,
  Input,
  Pagination,
  Row,
  Select,
  Space,
  Table,
  Typography,
  theme,
} from "antd";
import { Content } from "antd/es/layout/layout";
import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import TextWithBR from "../../../../components/common/TextWithBR";
import NotFound from "../../../../components/common/notFound";
import { routes } from "../../../../routes";
import { SearchUserContext } from "../searchContext";

const { Text } = Typography;
const { Option } = Select;
const { TextArea } = Input;
const { useToken } = theme;

const TableListdata = ({
  onSorter,
  onPageChange,
  permissionView,
  isAdmin,
  setOpenModal,
  dropDownCurerntStatus,
  onDelete,
  dataSource,
  onChangeStatusTable,
  setConfirmModal,
  oldSeleted,
  roleUser,
  no,
}) => {
  const navigate = useNavigate();
  const { token } = useToken();
  const [loading, setLoading] = useState(false);
  const {
    searchValues,
    setSearchValues,
    pageValues,
    setPageValues,
    search,
    setSearch,
  } = useContext(SearchUserContext);

  const columns = [
    {
      title: "อันดับ",
      key: "no",
      width: 70,
      dataIndex: "no",
      render: (text, record, index) => <span>{(no += 1)}</span>,
    },
    {
      title: "ปีงบประมาณ",
      dataIndex: "yearOfBudget",
      key: "yearOfBudget",
      sorter: true,
      width: 100,
      render: (yearOfBudget, record) => (
        <>
          <Text>{parseInt(yearOfBudget) + 543}</Text>
        </>
      ),
    },
    {
      title: "ชื่อบริษัท",
      dataIndex: "companyNameTh",
      key: "companyNameTh",
      sorter: true,
      width: 300,
      render: (companyNameTh, record) => (
        <>
          <TextWithBR
            line1={record.companyNameTh}
            line2={record.companyNameEn}
            color={"#82858E"}
          />
        </>
      ),
    },
    {
      title: "กลุ่มลูกค้าตามสัญชาติ",
      dataIndex: "regionGroupName",
      key: "regionGroupName",
      sorter: true,
      width: 350,
      render: (regionGroupName, record) => (
        <>
          <Text>{regionGroupName}</Text>
        </>
      ),
    },
    {
      title: (
        <Text>
          ตามขนาดพื้นที่ที่ประกอบกิจการ
          <br />
          เช่น ไร่-งาน-วา/ตร.ม.
        </Text>
      ),
      dataIndex: "areaByRai",
      key: "areaByRai",
      sorter: true,
      width: 250,
      render: (areaByRai, record) => (
        <>
          <Text>
            {record.areaByRai +
              " ไร่ " +
              record.areaByNgan +
              " งาน " +
              record.areaByWa +
              " วา"}
          </Text>
        </>
      ),
    },
    {
      title: "ตามประเภทพื้นที่ที่ต้องการ",
      dataIndex: "areaTypeName",
      key: "areaTypeName",
      sorter: true,
      width: 250,
      render: (areaTypeName, record) => (
        <>
          <Text>{areaTypeName}</Text>
        </>
      ),
    },
    {
      title: "กลุ่มลูกค้าตามกลุ่มอุตสาหกรรม",
      dataIndex: "industryTypeName",
      key: "industryTypeName",
      sorter: true,
      width: 250,
      render: (industryTypeName, record) => (
        <>
          <Text>{industryTypeName}</Text>
        </>
      ),
    },
    {
      title: "สถานะ",
      dataIndex: "status",
      key: "status",
      width: 230,
      sorter: true,
      render: (status, record) => (
        <Select
          // disabled={roleUser[0]?.isEdit ? false : true}
          disabled={true}
          // defaultValue={status}
          value={status}
          allowClear={false}
          showSearch={false}
          className="w-full"
          placeholder="เลือก"
          optionFilterProp="children"
          hasfeedback="true"
          onChange={(value, data) =>
            setConfirmModal({
              type: "change_status",
              show: true,
              id: record.futureCustomerId,
              status: value,
              status_name: value,
              old_data: status,
            })
          }
        >
          {dropDownCurerntStatus.map((option, i) => {
            return (
              <Option key={i} value={option.dataId}>
                {option.dataDetailTh}
              </Option>
            );
          })}
        </Select>
      ),
    },
    {
      title: "การจัดการ",
      dataIndex: "action",
      key: "action",
      width: 150,
      render: (action, record) => (
        <Space>
          <>
            {!roleUser[0]?.isEdit &&
              !roleUser[0].isDelete &&
              roleUser[0]?.isView && (
                <Button
                  className="btn-view"
                  shape="circle"
                  icon={<EyeFilled style={{ color: "#2E90FA" }} />}
                  onClick={() =>
                    navigate(routes.view_customer_future, {
                      state: {
                        id: record.futureCustomerId,
                        action_type: "VIEW",
                      },
                    })
                  }
                />
              )}

            {roleUser[0]?.isEdit && (
              <Button
                className="btn-edit"
                shape="circle"
                icon={<EditOutlined style={{ color: "#F79009" }} />}
                onClick={() =>
                  navigate(routes.view_customer_future, {
                    state: {
                      id: record.futureCustomerId,
                      action_type: "EDIT",
                    },
                  })
                }
              />
            )}
            {roleUser[0]?.isDelete && (
              <Button
                className="btn-delete"
                shape="circle"
                icon={<DeleteFilled style={{ color: "#F04438" }} />}
                onClick={() => onDelete(record.futureCustomerId)}
              />
            )}
          </>
        </Space>
      ),
    },
  ];

  return (
    <Content>
      <Row gutter={[24, 12]}>
        <Col span={24} style={{ margin: "20px 0px 10px 20px" }}>
          รายการทั้งหมด{" "}
          <span style={{ color: token.thPrimary, fontWeight: 700 }}>
            {pageValues?.total}
          </span>{" "}
          รายการ
        </Col>
        <Col span={24}>
          <Table
            locale={{ emptyText: <NotFound /> }}
            loading={loading}
            rowKey={"key"}
            dataSource={dataSource}
            columns={columns}
            pagination={false}
            scroll={{
              x: 2000,
            }}
            onChange={onSorter}
          />
        </Col>
        <Col span={24} align="right">
          <Pagination
            showSizeChanger
            defaultCurrent={pageValues.page + 1 || 1}
            total={pageValues.total || 10}
            onChange={onPageChange}
            showTotal={(total) => `รวม ${total} รายการ`}
          />
        </Col>
      </Row>
    </Content>
  );
};

export default TableListdata;
